module.exports = __webpack_public_path__ + "img/iolLeft.e2a64260.svg";